import { CardContent, Toolbar, Typography } from '@material-ui/core';
import React, { useState } from 'react';
import Card from 'src/components/Card';
import styles from './List.styles';
import { createUseStyles } from 'src/theming';
import InterventionOrderTable from './components/InterventionOrderTable';
import { InterventionOrderCriteria } from 'src/interfaces/api/InterventionOrder';
import Button from 'src/components/Button';
import SearchView from './components/SearchView';
import useScreenBreakpoint from 'src/hooks/useMediaQuery';

const useStyles = createUseStyles(styles);

const List = ({ history }) => {
  const screenBreakPoint = useScreenBreakpoint();
  const classes = useStyles();

  const [searchCriteria, setSearchCriteria] = useState<InterventionOrderCriteria>({
    status: undefined,
  });

  const handleAddInterventionOrder = () => {
    history.push('/dashboard/intervention-orders/new');
  };

  return (
    <div id='appView' className='div-entity'>
      <Card className={classes.root}>
        <Toolbar>
          <Typography variant='h6' className={classes.title} component='div'>
            Bon d'interventions
          </Typography>

          <Button variant='contained' color='primary' onClick={handleAddInterventionOrder}>
            {screenBreakPoint === 'xs' ? '+' : '+ Nouveau'}
          </Button>
        </Toolbar>

        <CardContent>
          <SearchView searchCriteria={searchCriteria} onCriteriaChange={(criteria) => setSearchCriteria(criteria)} />
          <InterventionOrderTable searchCriteria={searchCriteria} />
        </CardContent>
      </Card>
    </div>
  );
};

export default List;
